import { AudioRecorderService } from '@philips-internal/emr-design-system-web-services';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import TimerService from '../../../../utils/timer-service';

export type Transcription = {
  speaker: string;
  timer: string;
  transcript: string;
};

export enum RecordingState {
  INACTIVE = 'inactive',
  RECORDING = 'recording',
  PAUSED = 'paused',
}

export enum RecordingEvent {
  START = 'start',
  PAUSE = 'pause',
  RESUME = 'resume',
}

export default abstract class SmartcareTranscription {

  protected transcription: Transcription[];
  protected audiRecordService: AudioRecorderService;
  protected timerService: TimerService;

  constructor() {
    this.transcription = [];
    this.audiRecordService = new AudioRecorderService();
    this.timerService = new TimerService()
  }

  public addTranscription(transcription: Transcription): void {
    this.transcription.push(transcription);
  }

  public getTranscriptionData(): string {
    return this.transcription
      .map(({ speaker, timer, transcript }) => `${MessageService.translate('text.person')} ${speaker} - ${timer}:\n${transcript}`)
      .join('\n\n');
  }

  public cleanTranscription(): void {
    this.transcription = []
  }

  public transcriptionIsEmpty(): boolean {
    return this.transcription.length === 0;
  }

  public getAudioRecordInstance(): AudioRecorderService {
    if (!this.audiRecordService) {
      this.audiRecordService = new AudioRecorderService();
    }
    return this.audiRecordService;
  }

  public getStream(): MediaStream | undefined {
    return this.audiRecordService.stream;
  }

  public getState(): string {
    return this.audiRecordService.state;
  }
}